export default __webpack_public_path__ + "static/media/section-about-img-4.86aea65e.png";